module.exports = __webpack_public_path__ + "img/tooltip_01-vallone-lax-white.08799fb7.jpg";